import { Injectable } from '@angular/core';
import { EventNeoBuild, EventNeoTyped, EventTypeData } from '@fichaje/interfaces/ficha-event.interface';
import { EventDatum, Events } from '@fichaje/interfaces/schedule.interface';

export type EventTypeId =
'jornada' | 'jornadaFlexible' | 'nuevoEventoFlexible' | 'eventoFlexible' | 'horasExtra'




@Injectable({
  providedIn: 'root',
})
export class SetEventTypeService {

// 'Undefined'|'Jornada'|'Jornada Flexible'|'Nuevo Evento Flexible'|'Evento Flexible'|'Horas Extra'|
// 'Permiso Dia Completo'|'Permiso Dia Parcial'|'Compensación de Saldo'|'Localizado'|'Incapacidad Temporal'|
// 'No Laboral'|'Vacaciones'|'Dia de Libre Disposicion'|'Festivo'|'Tipo No Evaluado';

  public eventsNeoTyped(events:EventNeoBuild[]|undefined){
    const eventsNeoTyped:EventNeoTyped[] = [];
    if (events) {
      for (const ev of events) {
        eventsNeoTyped.push( this.typer(ev) );
      }
    }
    return eventsNeoTyped;
  }


  private typer(ev:EventNeoBuild):EventNeoTyped {
    const buildEventType:EventTypeData = {
      eventTypeName: $localize`:@@setEventType.defaultUndefined:Tipo por defecto no definido`,
      eventTypeId: 'noDefinido',
      borderColor: '#f00',
      overwriteLabel: undefined,
      canOpenEventDetails: true,
      showKpiColors: true, // switch todos los colores de estado
      showExpectedStart: true, //poner una funcion de ser necesario
      showExpectedEnd: true, //poner una funcion de ser necesario
      showExpectedWorkedHours: true, //poner una funcion de ser necesario
    }

    const setWork = () => { // procesa solo los 'work'
      if ( ev.working_hours_expected > 0 && ev.type_of_flexible == '' && !ev.working_hours_expected_overtime ){
        buildEventType.eventTypeName = $localize`:@@setEventType.workday:Jornada`;
        buildEventType.eventTypeId = 'jornada'
        buildEventType.borderColor = '#2B98F3';

      } else if ( ev.working_hours_expected > 0  &&  ev.type_of_flexible =='jornada' ){
        buildEventType.eventTypeName = $localize`:@@setEventType.flexibleWorkday:Jornada Flexible`;
        buildEventType.eventTypeId = 'jornadaFlexible';
        buildEventType.overwriteLabel = $localize`:@@setEventType.newFlexibleWorkday:Nueva Jornada Flexible`
        buildEventType.borderColor = '#2B98F3';

      } else if ( ev.is_flexible && ev.type_of_flexible =='' && ev.id === 0 ){ //! se supone que es "  ev.type_of_flexible =='total' " pero no coincide
        // si flexible falce.. vacio
        // si es true, o es 'total' o 'jornada' o 'entrada'
        // total sin jornada o totalmente flexible, el tiepo que quieras
        // 'jornada + puedes empezar cuando quieras pero ahcer tus 8 horas
        //
        buildEventType.eventTypeName = $localize`:@@setEventType.flexibleEvent:Evento Flexible`;
        buildEventType.eventTypeId = 'nuevoEventoFlexible';
        buildEventType.borderColor = '#2B98F3';
        buildEventType.showExpectedStart = false;
        buildEventType.showExpectedEnd = false;
        // buildEventType.overwriteLabel = 'Nuevo Evento';
        buildEventType.canOpenEventDetails = true;
      } else if ( ev.is_flexible  &&  ( ev.type_of_flexible =='' || ev.type_of_flexible =='total' ) ){  //! se supone que es "  ev.type_of_flexible =='total' " pero no coincide
        // si flexible falce.. vacio
        // si es true, o es 'total' o 'jornada' o 'entrada'
        // total sin jornada o totalmente flexible, el tiepo que quieras
        // 'jornada + puedes empezar cuando quieras pero ahcer tus 8 horas
        //
        buildEventType.eventTypeName = $localize`:@@setEventType.flexibleEvent:Evento Flexible`;
        buildEventType.eventTypeId = 'eventoFlexible';
        buildEventType.borderColor = '#2B98F3';
        buildEventType.showExpectedStart = false;
        buildEventType.showExpectedEnd = false;
      } else if ( ev.is_overtime ){ //ev.working_hours_expected_overtime > 0 && ev.working_hours_expected == 0 ){ // && !ev.is_flexible
        buildEventType.eventTypeName = $localize`:@@setEventType.overtime:Horas Extra`;
        buildEventType.eventTypeId = 'horasExtra';
        buildEventType.borderColor = '#B469FF'; // B469FF  6C3F99
        // buildEventType.overwriteLabel = 'Nueva Hora Extra'
        buildEventType.showExpectedStart = true;
        // buildEventType.showExpectedEnd = true;
        // buildEventType.showExpectedEnd = true;
      } else {
        buildEventType.eventTypeName = $localize`:@@setEventType.workUndefined:Trabajo no definido`;
        buildEventType.eventTypeId = 'workUndefined';
        buildEventType.borderColor = 'pink';
      }
    }

    switch (ev.type) {
      case 'work':
        setWork()
        break;

      case 'others': //permioso, dia completo o parcial
        if ( ev.event_start_expected === ev.event_end_expected){
          buildEventType.eventTypeName = $localize`:@@setEventType.fullDayPermission:Permiso Día Completo`;
          buildEventType.eventTypeId = 'permisoDiaCompleto';
          buildEventType.borderColor = '#7C8F9A';
          buildEventType.overwriteLabel = $localize`:@@setEventType.fullDayPermissionLabel:Permiso día completo`;
          buildEventType.canOpenEventDetails = false;
        } else if ( ev.event_start_expected != ev.event_end_expected){
          buildEventType.eventTypeName = $localize`:@@setEventType.partialDayPermission:Permiso Día Parcial`;
          buildEventType.eventTypeId = 'permisoDiaParcial';
          buildEventType.borderColor = '#7C8F9A';
        }
        break;

      case 'saldo_compensable': //! aparentemente sin evento existente
        buildEventType.eventTypeName = $localize`:@@setEventType.balanceCompensation:Compensación de Saldo`;
        buildEventType.eventTypeId = 'compensacionDeSaldo';
        buildEventType.borderColor = '#7C8F9A';
        break;

      case 'libre':
        buildEventType.overwriteLabel = $localize`:@@setEventType.localized:Localizado`;
        buildEventType.eventTypeName = $localize`:@@setEventType.localized:Localizado`; //! revisar que mostrar, aparentemente solo expected
        buildEventType.eventTypeId = 'localizado';
        buildEventType.canOpenEventDetails = false;
        buildEventType.borderColor = '#E38A49';
        break;

      case 'it':
        buildEventType.overwriteLabel = $localize`:@@setEventType.temporaryDisability:Incapacidad Temporal`;
        buildEventType.eventTypeName = $localize`:@@setEventType.temporaryDisability:Incapacidad Temporal`;
        buildEventType.eventTypeId = 'incapacidadTemporal'
        buildEventType.borderColor = '#D7B741'; //CFBB5D
        buildEventType.canOpenEventDetails = false;
        break;

      case 'no_laboral':
        buildEventType.overwriteLabel = $localize`:@@setEventType.nonWorking:No Laboral`;
        buildEventType.eventTypeName = $localize`:@@setEventType.nonWorking:No Laboral`;
        buildEventType.eventTypeId = 'noLaboral';
        buildEventType.borderColor = '#7C8F9A';
        break;

      case 'holidays':
        buildEventType.overwriteLabel = $localize`:@@setEventType.vacations:Vacaciones`;
        buildEventType.eventTypeName = $localize`:@@setEventType.vacations:Vacaciones`;
        buildEventType.eventTypeId = 'vacaciones';
        buildEventType.canOpenEventDetails = false;
        buildEventType.borderColor = '#75B46B';
        break;

      case 'dld':
        buildEventType.overwriteLabel = $localize`:@@setEventType.personalDay:Día de Libre Disposición`;
        buildEventType.eventTypeName = $localize`:@@setEventType.personalDay:Día de Libre Disposición`;
        buildEventType.eventTypeId = 'diaDeLibreDisposicion';
        buildEventType.borderColor = '#7C8F9A';
        break;

      case 'festivo':
        buildEventType.overwriteLabel = $localize`:@@setEventType.holiday:Festivo`;
        buildEventType.eventTypeName = $localize`:@@setEventType.holiday:Festivo`;
        buildEventType.eventTypeId = 'festivo';
        buildEventType.borderColor = '#D42422';
        break;

      default:
        buildEventType.eventTypeName = $localize`:@@setEventType.typeNotEvaluated:Tipo no evaluado`;
        buildEventType.eventTypeId = 'typeUndefined';
        buildEventType.borderColor = 'pink';
        break;
    }

    const eventsNeoTyped:EventNeoTyped = {
      ...ev,
      eventTypeData:buildEventType
    }

    return eventsNeoTyped
  }




  // private setWork(ev:EventDatum) {

  //   // TODOS ESTOS SON TIPO WORK
  //   //? type = 'work'
  //     if ( ev.tiempo_previsto > 0 && ev.tipo_flexible == '' && !ev.tiempo_extra ){
  //       //* 'jornada'

  //     } else if ( ev.tiempo_previsto > 0  &&  ev.tipo_flexible =='jornada' ){
  //       //* 'jornadaFlexible';

  //     } else if ( ev.es_flexible && ev.tipo_flexible =='' && ev.id === 0 ){  //! se supone que es "  ev.tipo_flexible =='total' " pero no coincide
  //       //* 'nuevoEventoFlexible';

  //     } else if ( ev.es_flexible  &&  ( ev.tipo_flexible =='' || ev.tipo_flexible =='total' ) ){  //! se supone que es "  ev.tipo_flexible =='total' " pero no coincide
  //       //* 'eventoFlexible';

  //     } else if ( ev.tiempo_extra > 0 && ev.tiempo_previsto == 0 ){ //! && !ev.es_flexible
  //       //* 'horasExtra';

  //     } else {
  //       //* 'workUndefined';
  //     }


  //   //* NO SON TIPO WORK
  //   //? type = 'others'
  //     if ( ev.date_start === ev.date_end){
  //       //* 'permisoDiaCompleto';
  //     } else if ( ev.date_start != ev.date_end){
  //       //* 'permisoDiaParcial';
  //     }


  //     switch (ev.type) {
  //       case 'saldo_compensable': //! aparentemente sin evento existente
  //         //* 'compensacionDeSaldo';

  //         break;

  //       case 'libre':
  //         //* 'localizado';

  //         break;

  //       case 'it':
  //         //* 'incapacidadTemporal';

  //         break;

  //       case 'no_laboral':
  //         //* 'noLaboral';

  //         break;

  //       case 'holidays':
  //         //* 'vacaciones';

  //         break;

  //       case 'dld':
  //         //* 'diaDeLibreDisposicion';

  //         break;

  //       case 'festivo':
  //         //* 'festivo';

  //         break;
  //     }


  //   }

}


